
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "t": "1604125456107",
    "class": "icon",
    "viewBox": "0 0 1280 1024",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "p-id": "1947",
    "width": "200",
    "height": "200"
  },
  "children": [
    {
      "tag": "path",
      "attrsMap": {
        "d": "M1224.89765492 92.64843777L50.71328222 92.64843777C27.56507601 92.64843777 8.77812571 73.86148845 8.77812571 50.71328222 8.77812571 27.56507601 27.56507601 8.77812571 50.71328222 8.77812571L1224.89765492 8.77812571C1248.04586113 8.77812571 1266.83281143 27.56507601 1266.83281143 50.71328222 1266.83281143 73.86148845 1248.04586113 92.64843777 1224.89765492 92.64843777ZM92.64843777 344.25937491L1182.96249937 344.25937491C1229.25891181 344.25937491 1266.83281143 381.83327551 1266.83281143 428.12968794 1266.83281143 474.42610038 1229.25891181 512 1182.96249937 512L92.64843777 512C46.35202533 512 8.77812571 474.42610038 8.77812571 428.12968794 8.77812571 381.83327551 46.35202533 344.25937491 92.64843777 344.25937491ZM92.64843777 763.61093714L1182.96249937 763.61093714C1229.25891181 763.61093714 1266.83281143 801.18483676 1266.83281143 847.4812492L1266.83281143 931.35156223C1266.83281143 977.64797467 1229.25891181 1015.22187429 1182.96249937 1015.22187429L92.64843777 1015.22187429C46.35202533 1015.22187429 8.77812571 977.64797467 8.77812571 931.35156223L8.77812571 847.4812492C8.77812571 801.18483676 46.35202533 763.61093714 92.64843777 763.61093714Z",
        "p-id": "1948"
      }
    }
  ]
})
    }
  